import { Field } from 'components/Field'
import { FormFieldProps } from 'components/FormFields'
import styled, { css } from 'styled-components'

export const checkboxFieldStyles = css`
	label {
		font-size: 1.2rem;

		a {
			display: inline;
			width: auto;
			color: ${props => props.theme.colors.secondary.val};
		}
	}
`

const CheckBoxFieldView = styled.div`
	${checkboxFieldStyles}
`

export type CheckboxFieldProps = Omit<FormFieldProps, 'labelPos'> & {
	onChange: (isChecked: boolean) => void
	isChecked: boolean
	labelPos?: 'right' | 'left'
}

export const CheckboxField = ({
	name,
	isChecked,
	onChange,
	labelPos = 'right',
	...fieldProps
}: CheckboxFieldProps) => {
	const toggleCheck = () => {
		if (onChange) onChange(!isChecked)
	}

	const props = {
		onChange: toggleCheck,
		checked: isChecked,
		name,
		type: 'checkbox',
		id: name,
		value: isChecked ? 'checked' : '',
	}

	return (
		<CheckBoxFieldView>
			<Field {...fieldProps} name={name} labelPos={labelPos}>
				<input {...props} />
			</Field>
		</CheckBoxFieldView>
	)
}
